import { render, staticRenderFns } from "./PopularSearches.vue?vue&type=template&id=911ad5e4&scoped=true&"
import script from "./PopularSearches.vue?vue&type=script&lang=js&"
export * from "./PopularSearches.vue?vue&type=script&lang=js&"
import style0 from "./PopularSearches.vue?vue&type=style&index=0&id=911ad5e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911ad5e4",
  null
  
)

export default component.exports